import moment from 'moment';

import { activityTypes } from 'bundles/apex/activities/type/config';
import { formatDate, ISO_DATE_FORMAT } from 'helpers/formatters/date_time_formats';
import { deleteRequest, post, put } from 'helpers/api';
import { serializeParentOption } from 'bundles/crm/parent_helpers';

export function buildActivity(path, attributes = {}) {
  return {
    activityType: activityTypes.call.key,
    body: '',
    date: formatDate(moment(), ISO_DATE_FORMAT),
    path,
    ...attributes,
  };
}

export function saveActivity(activity) {
  activity = { ...activity };
  serializeParentOption(activity);
  const method = activity.id ? put : post;
  return method(activity.path, activity);
}

export function deleteActivity(activity) {
  return deleteRequest(activity.path);
}
